import Button from './ui/Button';
import Popup from './ui/Popup';
import { ReactComponent as MailIcon } from '../assets/icons/mail.svg';
import locales from '../locales.json';

const { VERIFY_TEXTS, COMMON_TEXTS } = locales;

const VerifyEmail = ({ email, onClose }) => (
  <Popup titleId="verify-title" icon={MailIcon} tone="info">
    <h1 className="sheet__title" id="verify-title">
      {VERIFY_TEXTS.title}
    </h1>

    <p className="pop__mail">{email}</p>
    <p className="sheet__body">{VERIFY_TEXTS.body}</p>

    <div className="pop__actions">
      <Button variant="ghost" block autoFocus onClick={onClose}>
        {COMMON_TEXTS.close}
      </Button>
    </div>
  </Popup>
);

export default VerifyEmail;
